

import en from 'config/strings'

//validation newsletter form
const validate = (values) => {
    const errors = {}

    if (values) {
        if (!values.name) {
            errors.name = en.require()
        }
    }

    return errors;
}

export default validate;

